module.exports = __webpack_public_path__ + "img/8_58.29b7c82c.png";